var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAddUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5458F117-15BD-4823-B229-0D50558E6E3C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S\\u0101kums",
    transform: "translate(-1077.000000, -238.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-content",
    transform: "translate(240.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blocks",
    transform: "translate(20.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block-3",
    transform: "translate(680.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(137.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "viewbox",
    x: 0,
    y: 0,
    width: 46,
    height: 46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,4 C33.4934102,4 42,12.5065898 42,23 C42,33.4934102 33.4934102,42 23,42 C12.5065898,42 4,33.4934102 4,23 C4,12.5065898 12.5065898,4 23,4 Z M23,6 C13.6111593,6 6,13.6111593 6,23 C6,28.4883213 8.60079382,33.3691947 12.6371553,36.477394 L13.4718817,35.7903229 C13.6911477,35.612636 13.93174,35.4550758 14.1899679,35.3198419 L18.5988153,33.0118577 C19.0183995,32.7917787 19.2793424,32.3705929 19.2793424,31.9114625 L19.2793424,30.3419763 L19.0675689,30.0627448 L18.8705112,29.7804865 C18.447234,29.150659 17.8714794,28.1382044 17.5481248,26.9094071 C17.0815906,26.5503557 16.8082925,26.0120158 16.8082925,25.4347826 L16.8082925,23.5375494 C16.8082925,23.0807905 16.9862081,22.6382609 17.3025025,22.2924901 L17.3025025,19.7696443 L17.2903333,19.6000727 L17.2870837,19.4044224 C17.2923354,18.8097357 17.4348336,17.661235 18.3363898,16.6743083 C19.3514971,15.5634783 20.998699,15 23.2330223,15 C25.4673457,15 27.1145476,15.5634783 28.1296549,16.6747826 C29.2999442,17.9558893 29.191218,19.5087747 29.1635422,19.7696443 L29.1635422,22.2924901 C29.4798366,22.6382609 29.6577522,23.0807905 29.6577522,23.5375494 L29.6577522,25.4347826 C29.6577522,26.1818182 29.2050558,26.8434783 28.5077256,27.1503557 C28.1509059,28.1468775 27.6601554,29.07083 27.0478292,29.9008696 C26.924771,30.0678261 26.8056663,30.2191304 26.6924923,30.3519368 L26.6924923,31.9555731 C26.6924923,32.4336759 26.9692499,32.8633992 27.4145331,33.0773123 L32.1357211,35.3426087 C32.4235987,35.4807961 32.6908336,35.6454328 32.9349163,35.832624 C33.1534794,36.0308628 33.3384044,36.2129506 33.4896913,36.3788873 C37.4532985,33.2670807 40,28.4309474 40,23 C40,13.6111593 32.3888407,6 23,6 Z",
    id: "icon",
    fill: "#667380",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "additional",
    transform: "translate(32.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "background",
    fill: "#FFFFFF",
    cx: 7,
    cy: 7,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,0 C10.8659932,0 14,3.13400675 14,7 C14,10.8659932 10.8659932,14 7,14 C3.13400675,14 0,10.8659932 0,7 C0,3.13400675 3.13400675,0 7,0 Z M7,4 C6.44771525,4 6,4.44771525 6,5 L6,6 L5,6 C4.48716416,6 4.06449284,6.38604019 4.00672773,6.88337887 L4,7 C4,7.55228475 4.44771525,8 5,8 L6,8 L6,9 C6,9.51283584 6.38604019,9.93550716 6.88337887,9.99327227 L7,10 C7.55228475,10 8,9.55228475 8,9 L8,8 L9,8 C9.51283584,8 9.93550716,7.61395981 9.99327227,7.11662113 L10,7 C10,6.44771525 9.55228475,6 9,6 L8,6 L8,5 C8,4.48716416 7.61395981,4.06449284 7.11662113,4.00672773 L7,4 Z",
    id: "icon",
    fill: "#0883EF"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddUser);
export default __webpack_public_path__ + "static/media/ic-add-user.c621a2c2ec428d8103cc83bd63559839.svg";
export { ForwardRef as ReactComponent };